import React, { useEffect } from 'react';

import { Downgraded, useState } from '@hookstate/core';
import UserCheckList from './userCheckList';
import CustomTabs from '../../../sharedcomponents/customTabs/customTabs';

const UserList = (props) => {
    const tabValue = useState(0);
    const allUsers = useState([]);
    const collectionTabs = useState([
        {
            label: 'All Users',
            value: 0,
            component: UserCheckList,
            data: [],
        },
        // {
        //     label: 'Individuals',
        //     value: 1,
        //     component: UserCheckList,
        //     data: [],
        // },
        // {
        //     label: 'Groups',
        //     value: 2,
        //     component: UserCheckList,
        //     data: [],
        // },
    ]);

    useEffect(() => {
        if (props.users && allUsers.get() && allUsers.get().length == 0) {
            const filterData = props.users.filter((user) => user.actualData.scheduleDateTime === "0001-01-01T00:00:00");
            let newUsers = filterData;
            if (newUsers) {
                if (
                    collectionTabs.attach(Downgraded).get()[0].data
                        .length == 0
                ) {
                    collectionTabs
                        .attach(Downgraded)
                        .get()
                        .map((item, index) => {
                            if (index == 0) {
                                collectionTabs[index].set({
                                    ...item,
                                    data: newUsers,
                                });
                            }
                        });
                }
                allUsers.set(newUsers);
            }
        }

        if (props.search) {
            let newCollectionTabs = [...allUsers.attach(Downgraded).get()];
            let newUserData = newCollectionTabs.filter(user => {
                return user.actualData.participant.toLowerCase().indexOf(props.search.toLowerCase().trim()) > -1 ||
                    (user.actualData.userType && user.actualData.userType !== null && user.actualData.userType
                        .toLowerCase()
                        .indexOf(props.search.toLowerCase().trim()) > -1) ||
                    (user.actualData.userTags && user.actualData.userTags !== null && user.actualData.userTags
                        .toLowerCase()
                        .indexOf(props.search.toLowerCase().trim()) > -1)
            });
            collectionTabs[0].data.set(newUserData);
        }
        else {
            collectionTabs[0].data.set(allUsers.attach(Downgraded).get());
        }
    }, [props]);
    const handleChange = (value) => {
        tabValue.set(value);
    };
    return (
        <CustomTabs
            value={tabValue.get()}
            handleChange={handleChange}
            data={collectionTabs.attach(Downgraded).get()}
            fixedTabs={true}
            centered
            variant="fullWidth"
            checkUsers={props.checkUsers}
            selectedUsers={props.selectedUsers}
        />
    );
};
export default UserList;
